export const messages = {
  en: {
    couponPropertyUserManage: {
      search: {
        title: 'Search Conditions',
        couponId: 'Coupon ID',
        couponName: 'Coupon Name',
        validityDay: 'Validity Day',
        userName: 'User Name',
        tel: 'Phone Number',
        toType: 'Usage',
        selectToType: 'Select Usage',
        shopping: 'Shopping',
        payment: 'Payment',
        repair: 'Repair Coupon',
        parking: 'Parking Coupon',
        state: 'Status',
        selectState: 'Select Status',
        unused: 'Unused',
        used: 'Used'
      },
      list: {
        title: 'Owner Coupons'
      },
      table: {
        couponId: 'ID',
        couponName: 'Coupon Name',
        value: 'Face Value',
        validityDay: 'Validity',
        userName: 'User Name',
        tel: 'Phone',
        toType: 'Usage',
        quantity: 'Quantity',
        sheet: 'Sheet',
        state: 'Status',
        startTime: 'Effective Time',
        unused: 'Unused',
        used: 'Used'
      },
      fetchError: 'Failed to fetch coupon data'
    }
  },
  zh: {
    couponPropertyUserManage: {
      search: {
        title: '查询条件',
        couponId: '优惠券编号',
        couponName: '优惠券名称',
        validityDay: '有效期',
        userName: '用户名称',
        tel: '手机号',
        toType: '用途',
        selectToType: '选择用途',
        shopping: '购物',
        payment: '缴费',
        repair: '维修劵',
        parking: '停车劵',
        state: '状态',
        selectState: '请选择状态',
        unused: '未使用',
        used: '已使用'
      },
      list: {
        title: '业主优惠券'
      },
      table: {
        couponId: '编号',
        couponName: '优惠券名称',
        value: '面值',
        validityDay: '有效期',
        userName: '用户名称',
        tel: '手机号',
        toType: '用途',
        quantity: '数量',
        sheet: '张',
        state: '状态',
        startTime: '生效时间',
        unused: '未使用',
        used: '已使用'
      },
fetchError: '獲取優惠券數據失敗'
    }
  },
  'zh-TW': {
    couponPropertyUserManage: {
      search: {
        title: '查詢條件',
        couponId: '優惠券編號',
        couponName: '優惠券名稱',
        validityDay: '有效期',
        userName: '用戶名稱',
        tel: '手機號',
        toType: '用途',
        selectToType: '選擇用途',
        shopping: '購物',
        payment: '繳費',
        repair: '維修劵',
        parking: '停車劵',
        state: '狀態',
        selectState: '請選擇狀態',
        unused: '未使用',
        used: '已使用'
      },
      list: {
        title: '業主優惠券'
      },
      table: {
        couponId: '編號',
        couponName: '優惠券名稱',
        value: '面值',
        validityDay: '有效期',
        userName: '用戶名稱',
        tel: '手機號',
        toType: '用途',
        quantity: '數量',
        sheet: '張',
        state: '狀態',
        startTime: '生效時間',
        unused: '未使用',
        used: '已使用'
      },
      fetchError: '獲取優惠券數據失敗'
    }
  }
}